import { configureStore, Store } from "@reduxjs/toolkit";
import rootReducer, { rootApiSlice } from "./rootReducer";
import { dashboardReducer } from "../pages/dashboardPage/DashboardSlice";
import { qualificationApiSlice } from "../common/api/qualification";
import { establishmentApiSlice } from "../common/api/establishment";
import { qualificationDetailReducer } from "../pages/qualificationDetailPage/QualificationDetailSlice";
import { certificateReducer } from "../pages/certificatePage/CertificateSlice";
import { employeeApiSlice } from "../common/api/employee";
import { qualificationListReducer } from "../pages/qualificationListPage/QualificationListSlice";
import { certificateApiSlice } from "../common/api/certificate";
import { reviewReducer } from "../pages/reviewPage/ReviewSlice";
import { editCertificateModalReducer } from "../modals/EditCertificateModal/EditCertificateModalSlice";
import { createCertificateModalReducer } from "../modals/CreateCertificateModal/CreateCertificateModalSlice";
import { editEmployeeModalReducer } from "../modals/EditEmployeeModal/EditEmployeeModalSlice";
import { functionGroupApiSlice } from "../common/api/functionGroup";
import { employeeReducer } from "../pages/employeePage/EmployeeSlice";
import { createEmployeeModalReducer } from "../modals/CreateEmployeeModal/CreateEmployeeModalSlice";
import { notificationApiSlice } from "../common/api/notification";
import { notificationsReducer } from "../pages/notificationsPage/NotificationsSlice";
import { employeeDetailReducer } from "../pages/employeeDetailPage/EmployeeDetailSlice";
import { pickEstablishmentModalReducer } from "../modals/PickEstablishmentModal/PickEstablishmentModalSlice";
import { employeeInactiveReducer } from "../pages/employeeInactivePage/EmployeeInactiveSlice";
import { establishmentsReducer } from "../pages/establishmentsPage/EstablishmentsSlice";
import { educatorApiSlice } from "../common/api/educator";
import { qualificationStandardApiSlice } from "../common/api/qualificationStandard";
import { deactivateEmployeeConfirmationModalReducer } from "../modals/DeactivateEmployeeConfirmationModal/DeactivateEmployeeConfirmationModalSlice";
import { rejectCertificateModalReducer } from "../modals/RejectCertificateModal/RejectCertificateModalSlice";
import { scheduledQualificationsReducer } from "../pages/scheduledQualificationsPage/ScheduledQualificationsSlice";
import { upsertScheduleQualificationModalReducer } from "../modals/UpsertScheduleQualificationModal/UpsertScheduleQualificationModalSlice";
import { scheduledQualificationApiSlice } from "../common/api/scheduledQualification";
import { certificateExpiryReducer } from "../pages/certificateExpiryPage/CertificateExpirySlice";
import { expiredCertificateApiSlice } from "../common/api/expiredCertificate";

export const store: Store = configureStore({
    reducer: {
        root: rootReducer,
        [rootApiSlice.reducerPath]: rootApiSlice.reducer,
        [employeeApiSlice.reducerPath]: employeeApiSlice.reducer,
        [qualificationApiSlice.reducerPath]: qualificationApiSlice.reducer,
        [establishmentApiSlice.reducerPath]: establishmentApiSlice.reducer,
        [certificateApiSlice.reducerPath]: certificateApiSlice.reducer,
        [functionGroupApiSlice.reducerPath]: functionGroupApiSlice.reducer,
        [notificationApiSlice.reducerPath]: notificationApiSlice.reducer,
        [educatorApiSlice.reducerPath]: educatorApiSlice.reducer,
        [qualificationStandardApiSlice.reducerPath]:
            qualificationStandardApiSlice.reducer,
        [scheduledQualificationApiSlice.reducerPath]:
            scheduledQualificationApiSlice.reducer,
        [expiredCertificateApiSlice.reducerPath]:
            expiredCertificateApiSlice.reducer,
        dashboard: dashboardReducer,
        qualificationDetail: qualificationDetailReducer,
        achievedQualifications: certificateReducer,
        qualificationList: qualificationListReducer,
        review: reviewReducer,
        employee: employeeReducer,
        createCertificateModal: createCertificateModalReducer,
        deactivateEmployeeConfirmationModal:
            deactivateEmployeeConfirmationModalReducer,
        editCertificateModal: editCertificateModalReducer,
        editEmployeeModal: editEmployeeModalReducer,
        createEmployeeModal: createEmployeeModalReducer,
        notifications: notificationsReducer,
        employeeDetail: employeeDetailReducer,
        employeeInactive: employeeInactiveReducer,
        pickEstablishmentModal: pickEstablishmentModalReducer,
        establishments: establishmentsReducer,
        rejectCertificateModal: rejectCertificateModalReducer,
        scheduledQualifications: scheduledQualificationsReducer,
        upsertScheduleQualificationModal:
            upsertScheduleQualificationModalReducer,
        certificateExpiry: certificateExpiryReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({}).concat(
            rootApiSlice.middleware,
            qualificationApiSlice.middleware,
            establishmentApiSlice.middleware,
            employeeApiSlice.middleware,
            certificateApiSlice.middleware,
            functionGroupApiSlice.middleware,
            notificationApiSlice.middleware,
            educatorApiSlice.middleware,
            qualificationStandardApiSlice.middleware,
            scheduledQualificationApiSlice.middleware,
            expiredCertificateApiSlice.middleware,
        ),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
